import { render, staticRenderFns } from "./msg-delete-popup.html?vue&type=template&id=2aa69bd1&scoped=true&external"
import script from "./msg-delete-popup.js?vue&type=script&lang=js&external"
export * from "./msg-delete-popup.js?vue&type=script&lang=js&external"
import style0 from "./msg-delete-popup.scss?vue&type=style&index=0&id=2aa69bd1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa69bd1",
  null
  
)

export default component.exports